enum VerifyPDFToolTip {
    CertificatePDFCertificatednoFile = "Certificate PDF unavailable: pending Certification Body administration",
    CertificatePDFNotCertificated="Certificate PDF unavailable: Site not certificated",
    BasicOnlyORCertificateOnly = "Certificate PDF unavailable: access prohibited by Audit Owner"
   
  }
  export default VerifyPDFToolTip;